<template>
  <div>
    <DiningInfo ref="refDiningInfo" />
    <van-popup v-model="visible" position="top" class="HideScrollbar" :close-on-click-overlay="false" :style="{
      height: '100%',
      width: '100%',
      overflow: 'hidden',

    }">

      <!-- <Header title="內用帳單 Check" /> -->
      <van-nav-bar :title="txtTitle()" fixed placeholder z-index="999" :right-text="txtDiningInfo()"
        @click-right="$refs.refDiningInfo.show()">
      </van-nav-bar>

      <div class="main" v-if="orderh">
        <!-- <div id="canvas"> canvas</div> -->
        <!-- <canvas id="canvas"></canvas> -->
        <!-- <vue-qr text="Hello 中文 world!" :size="200"></vue-qr> -->
        <BellButton />
        <TimeTip v-if="sGetConfig('chkShowTimeTip')" />
        <!-- 允許傳送:{{ checkCSendTime() }} -->
        <!-- 下次允許傳送時間:{{ sTimeTip.nextSendTime }}

        txtBtnNext:{{ txtBtnNext }} -->
        <!-- <pre>{{ sTimeTip }}</pre> -->
        <van-row>
          <van-col span="12"><i class="el-icon-s-order" />{{ orderh.TblName }}</van-col>
          <van-col span="12" align="right">
            <i class="el-icon-s-custom" />{{ orderh.CustTotal }}
          </van-col>
        </van-row>
        <van-divider />



        <el-timeline>
          <el-timeline-item v-for="t in gGroupBy(orderi, 'OrderTime')" :key="t" :timestamp="t" placement="top">
            <van-row v-for="oi in orderi.filter((r) => r.OrderTime == t)" :key="oi.rno">
              <van-col span="17">
                <span v-if="isS1(oi)">{{ oi.ItemName }} </span>
                <span v-else class="s2">{{ oi.ItemName }} </span>
                <span class="note" v-if="oi.Remark"> {{ oi.Remark }}</span>
              </van-col>

              <van-col span="2">x<span class="C1">{{ oi.Qty }}</span></van-col>
              <van-col span="5" align="right">
                <span v-if="oi.Amt < 0" class="C4">{{ oi.Amt }}</span>
                <span v-if="oi.Amt >= 0" class="C1">{{ oi.Amt }}</span>
                元
              </van-col>
            </van-row>
          </el-timeline-item>
        </el-timeline>
        <div class="footer">
          <van-divider />
          <van-row>
            <van-col span="12">小計 Sub Total</van-col>
            <van-col span="12" align="right"><span class="C1">{{ gSum(orderi, "Amt") }}</span>元</van-col>
            <van-col span="12">服務費 Service</van-col>
            <van-col span="12" align="right"><span class="C1">{{ serviceAmt() }}</span>元</van-col>
          </van-row>
          <van-divider />
          <van-row style="margin-bottom:1rem">
            <van-col span="12">合計 Grand Total</van-col>
            <van-col span="12" align="right"><span class="C1">{{ gSum(orderi, "Amt") + serviceAmt() }}</span>元</van-col>
          </van-row>

          <!-- <div>限點時間{{ sGetConfig('txtBuffetMin') }}分鐘</div>
          <div>最後傳送時間{{ $store.state.sLastSendTime.substr(11,5) }}</div>
          <div>超時{{ gOverSendTime() }}</div> -->
          <!-- <div style="text-align: center; margin-top: 2rem" class="C1" v-if="sGetConfig('chkBuffet')"> -->
          <!-- <span
            >限點時間{{ sGetConfig("MaxOrderTime") }}分鐘 ,最後點餐時間
            {{ $store.state.sLastSendTime.substr(11, 5) }}</span
          > -->
          <!-- <div>{{ $store.state.sLastSendTime }}</div> -->
          <!-- <div>{{ gOverSendTime()}}</div> -->
          <!-- </div> -->
          <van-divider content-position="center">Powered by FitSoft</van-divider>
          <div style="height: 10rem" />
        </div>

      </div>

      <Footer :b1="txtBtnNext" @b1c="close()" anime />
    </van-popup>

  </div>
</template>

<style scoped>
.van-row {
  line-height: 2rem;
}

.s2 {
  color: grey;
}

.van-popup {
  width: 100%;
  min-height: 100vh;
}

.main {
  padding: 1rem;
  line-height: 2rem;
  font-size: 1rem;
  overflow: scroll;
  height: 100%;
}
</style>
<script>
// @ is an alias to /src
const fits = require("../../../mixin/lib-fits-front");
// const moment = require("moment");
import TimeTip from "./Child/TimeTip.vue";
import DiningInfo from "./ocheck-child/FrmDiningInfo.vue";
import moment from "moment";

import BellButton from "../../../views/Index/BellButton.vue";
// import qrcode from "qrcode";

// import VueQrcode from 'vue-qrcode'
// var QRCode = require('qrcode')

export default {
  components: {
    TimeTip,
    DiningInfo,
    BellButton,
  },
  data() {
    return {
      orderh: null,
      orderi: null,
      visible: false,
      txtBtnNext: "",
      timer: null,
      title: "",
    };
  },
  methods: {
    txtTitle() {
      let txt = "內用帳單 Check" + fits.now();
      if (this.sGetConfig("chkSetFrmOcheckTitle")) {
        if (this.title != "") txt = this.title;
      }
      return txt;
      // return "最後可點餐時間13:22剩餘70分鐘";
      // return "最後可點餐時間最後可點餐時間" + this.sTimeTip.timeE.substr(11, 5);
    },
    txtDiningInfo() {
      if (this.sGetConfig('txtDiningInfo') != "") return "用餐須知";
      return "";
    },

    checkCSendTime() {
      if (!this.sOrderI) return true;
      let orderi = this.sOrderI.filter((r) => r.POSID == "eat");
      if (orderi == 0) return true;

      let lastSendTime = orderi[orderi.length - 1].FileDate; // 最後傳送時間
      let now = fits.now();
      let time = fits.dateAdd(lastSendTime, this.sGetConfig("cSendTime")); // 下次可傳送時間
      if (now > time) return true;
      // console.log("lastSendTime", lastSendTime);
      // console.log("now", fits.now());
      // console.log("time", time);
      return false;
    },
    close() {
      if (this.gOverSendTime())
        return this.gMsgbox(this.sGetConfig("txtOverMaxOrderTimeText"));

      if (this.sGetConfig("chkCantOrderTimeLocked")) { //在續點時間未到時，禁止先加入購物車
        if (!this.checkCSendTime()) return this.gMsgbox("請稍候進行續點");
      }

      this.orderh = null;
      this.orderi = null;
      this.visible = false;
      clearInterval(this.timer);
    },

    showDiningInfo() {
      if (this.txtDiningInfo() == "") return;
      setTimeout(() => {
        let info = JSON.parse(sessionStorage.getItem("diningInfo"));
        console.log("info", info);

        if (info) {
          if (info.tblid == this.orderh.TblName || info.day != fits.today()) return;
        }

        let raw = {
          day: fits.today(),
          tblid: this.orderh.TblName,
          viewed: true,
        };
        sessionStorage.setItem("diningInfo", JSON.stringify(raw));
        this.$refs.refDiningInfo.show();
      }, 100);

    },
    show(orderh, orderi) {
      let servID = fits.str(orderh.ServID);
      let passcode = this.$route.query.PassCode;
      // if (servID != passcode && passcode != "mpo" && passcode != "sure")
      if (servID != passcode && passcode != "mpo")
        return console.log("驗證碼不正確,不顯示orderh");
      this.orderh = orderh;
      this.orderi = orderi;
      this.txtBtnNext = this.getBtnText();
      this.visible = true;


      this.showDiningInfo();

      // console.log("ss", sessionStorage.getItem("temp"));
      this.timer = setInterval(() => {
        this.txtBtnNext = this.getBtnText();
        this.setTitle();
      }, 1000);


      // var canvas = document.getElementById('canvas')

      // qrcode.toCanvas(canvas, 'sample text', function (error) {
      //   if (error) console.error(error)
      //   console.log('success!');
      // })
    },
    setTitle() {
      let tt = this.calcTimeTip();
      let timee = moment(tt.timeE);
      let s = moment().diff(timee, "s");
      let m = Math.floor(s / 60 * -1);
      s = s % 60 * -1;
      let ms = "";
      if (s < 0) {
        ms = "逾時";
      } else {
        s = s.toString().padStart(2, "0");
        m = m.toString().padStart(2, "0");
        ms = m + ":" + s;
      }
      let ms2 = tt.maxDiningTime.substr(-5);
      if (tt.maxDiningTime == tt.timeB) ms2 = "";

      // this.title = [ms, tt.maxDiningTime];
      this.title = "可點時間" + ms;
      if (ms2 != "") this.title += " 離座時間" + ms2;

    },
    async showAndLoad() {
      // try {
      //   this.gShowLoading();
      //   var res = await this.$parent.getOCheck();
      //   this.orderh = res.data.orderh;
      //   this.orderi = res.data.orderi;
      //   var amt = this.gSum(this.orderi, "Amt");
      //   if (amt > 0) {
      //     this.visible = true;
      //   }
      //   this.gClearLoading();
      // } catch (error) {
      //   console.log(error);
      // }
      try {
        this.gShowLoading();
        var tblid = this.$route.query.tblid;
        var passcode = this.$route.query.PassCode;
        var query = { tblid: tblid, passcode: passcode };
        var res = await this.apiGetOCheck(query);
        // console.log("ocheck.res", res);
        var orderi = res.data.orderi;
        var sum = this.gSum(orderi, "Amt");
        if (sum == 0) {
          if (this.sOrderI.length > 0) {
            if (this.sGetConfig("chkHideCheckWhenAmt0")) {
              this.gMsgbox("無交易");
              this.gClearLoading();
              return;
            }
          }
        }
        // if (sum == 0) {
        //   this.gMsgbox("無交易");
        //   this.gClearLoading();
        //   return;
        // }

        this.visible = true;
        // this.gClearLoading;
        // // console.log(ress);
        // //  return ;
        this.show(res.data.orderh, res.data.orderi);
        this.gClearLoading();
      } catch (error) {
        console.log("getOCheck()", error);
        this.gClearLoading();
      }
    },
    isS1(obj) {
      if (obj.ItemType == "S2") {
        return false;
      }
      if (obj.ItemType == "A1") {
        return false;
      }
      return true;
    },
    serviceAmt() {
      var service = 0;
      if (this.sConfig.calcService.value) {
        service = Math.round(this.gSum(this.orderi, "Amt") * 0.1);

        if (this.sConfig["chkServiceRate05"].value)
          service = Math.round(this.gSum(this.orderi, "Amt") * 0.05);

        if (this.sConfig["serviceRate07"].value)
          service = Math.round(this.gSum(this.orderi, "Amt") * 0.07);

      }
      return service;
    },

    getBtnText() {
      // if (!this.checkData()) {
      //   this.anime = false;
      //   return "請選擇附餐 Side Check";
      // }

      // this.anime = true;
      // if (this.obj.rno) {
      //   return "更新餐點 Update";
      // }

      // if (this.sGetConfig("chkCartNoSumAmt"))
      //   return "加入" + this.obj.Qty + "份  " + " Add " + this.obj.Qty;

      if (this.gOverSendTime()) return "歡迎再次光臨 Welcome Again";
      // if (this.gOverSendTime()) return "歡迎再次光臨 Thank you. Please come again";

      if (this.sGetConfig("chkCantOrderTimeLocked")) { //在續點時間未到時，禁止先加入購物車
        let ss = fits.dateDiff(this.sTimeTip.lastSendTime, "s");
        let span = this.sTimeTip.span;
        let cooldown = span * 60;

        if (ss - (cooldown) < 0) {
          return `等候${cooldown - ss} 秒下一輪加點`;
        }
      }

      return "繼續選擇餐點 Continue";
    },
  },
};
</script>
